
export const testimonials = [
  {
    id: 1,
    name: 'Mike Rodriguez',
    company: 'Rodriguez Electrical Services',
    location: 'Phoenix, AZ',
    trade: 'electrical',
    rating: 5,
    age: '45',
    ethnicity: 'Hispanic',
    gender: 'male',
    appearance: 'navy blue work shirt with tool belt',
    quote: 'Working with Million Dollar Contractors completely transformed our business. Within 6 months, our monthly revenue jumped from $45K to $180K. Their SEO and Google Ads strategy put us on the map, and now we are turning away work. Best investment we ever made.',
    result: '300% Revenue Increase in 6 Months'
  },
  {
    id: 2,
    name: 'Sarah Chen',
    company: 'Elite HVAC Solutions',
    location: 'Austin, TX',
    trade: 'HVAC',
    rating: 5,
    age: '38',
    ethnicity: 'Asian',
    gender: 'female',
    appearance: 'red company polo shirt with glasses',
    quote: 'The AI chatbot integration alone has been a game-changer. We are capturing leads 24/7 now, even when our office is closed. Our booking rate increased by 65% and our team can focus on actual work instead of answering the same questions all day.',
    result: '65% Increase in Booking Rate'
  },
  {
    id: 3,
    name: 'James Patterson',
    company: 'Patterson Plumbing Co',
    location: 'Denver, CO',
    trade: 'plumbing',
    rating: 5,
    age: '52',
    ethnicity: 'Caucasian',
    gender: 'male',
    appearance: 'gray work uniform with beard',
    quote: 'Their reputation management service has been incredible. We went from 12 reviews to over 200 five-star reviews in less than a year. Now customers are calling us specifically because of our stellar online reputation. The ROI speaks for itself.',
    result: '200+ Five-Star Reviews in 12 Months'
  },
  {
    id: 4,
    name: 'David Martinez',
    company: 'Martinez Roofing Pros',
    location: 'Dallas, TX',
    trade: 'roofing',
    rating: 5,
    age: '41',
    ethnicity: 'Hispanic',
    gender: 'male',
    appearance: 'orange safety vest with hard hat',
    quote: 'Our new website is absolutely stunning and actually converts visitors into customers. Combined with their social media strategy, we are getting 3-4 qualified leads per day. We have had to hire two more crews to keep up with demand. These guys know contractor marketing inside and out.',
    result: '3-4 Qualified Leads Per Day'
  },
  {
    id: 5,
    name: 'Jennifer Thompson',
    company: 'Thompson Landscaping & Design',
    location: 'Seattle, WA',
    trade: 'landscaping',
    rating: 5,
    age: '35',
    ethnicity: 'Caucasian',
    gender: 'female',
    appearance: 'green company shirt with ponytail',
    quote: 'Before working with Million Dollar Contractors, we were struggling to stand out in a crowded market. Their targeted marketing campaigns and beautiful portfolio showcase helped us land high-end residential projects. Our average project value has doubled, and we are booked solid for the next 4 months.',
    result: 'Average Project Value Doubled'
  },
  {
    id: 6,
    name: 'Robert Williams',
    company: 'Williams Pest Solutions',
    location: 'Atlanta, GA',
    trade: 'pest control',
    rating: 5,
    age: '48',
    ethnicity: 'African American',
    gender: 'male',
    appearance: 'white company polo with short hair',
    quote: 'The local SEO work they did for us was phenomenal. We now rank #1 for pest control in Atlanta and surrounding areas. Our call volume tripled within 90 days, and the quality of leads is outstanding. We have expanded to three new service areas thanks to their marketing expertise.',
    result: 'Call Volume Tripled in 90 Days'
  }
];
